<app-feature-list-container>
  <div class="feature-grid-container" viFeatureGrid>
    <!-- Supply temperature -->
    <!-- ventilation.sensors.temperature.supply -->
    <app-feature-list-item
      data-at-ventilation-sensors-temperature-supply
      *ngIf="ventilationSensorsTemperatureSupply$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.VENTILATION.SENSOR_READINGS.SUPPLY_TEMPERATURE' | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | sensorStatusConnected | unit: 'value'
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- Supply humidity -->
    <!-- ventilation.sensors.humidity.supply -->
    <app-feature-list-item
      data-at-ventilation-sensors-humidity-supply
      *ngIf="ventilationSensorsHumiditySupply$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.VENTILATION.SENSOR_READINGS.SUPPLY_HUMIDITY' | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | sensorStatusConnected | unit: 'value'
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- Outdoor temperature -->
    <!-- ventilation.sensors.temperature.outdoor -->
    <app-feature-list-item
      data-at-ventilation-sensors-temperature-outdoor
      *ngIf="ventilationSensorsTemperatureOutside$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.VENTILATION.SENSOR_READINGS.OUTDOOR_TEMPERATURE' | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | sensorStatusConnected | unit: 'value'
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- Outdoor humidity -->
    <!-- ventilation.sensors.humidity.outdoor -->
    <app-feature-list-item
      data-at-ventilation-sensors-humidity-outdoor
      *ngIf="ventilationSensorsHumidityOutdoor$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.VENTILATION.SENSOR_READINGS.OUTDOOR_HUMIDITY' | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- Exhaust temperature -->
    <!-- ventilation.sensors.temperature.exhaust -->
    <app-feature-list-item
      data-at-ventilation-sensors-temperature-exhaust
      *ngIf="ventilationSensorsTemperatureExhaust$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.VENTILATION.SENSOR_READINGS.EXHAUST_TEMPERATURE' | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | sensorStatusConnected | unit: 'value'
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- Exhaust humidity -->
    <!-- ventilation.sensors.humidity.exhaust -->
    <app-feature-list-item
      data-at-ventilation-sensors-humidity-exhaust
      *ngIf="ventilationSensorsHumidityExhaust$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.VENTILATION.SENSOR_READINGS.EXHAUST_HUMIDITY' | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | sensorStatusConnected | unit: 'value'
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- Extract temperature -->
    <!-- ventilation.sensors.temperature.extract -->
    <app-feature-list-item
      data-at-ventilation-sensors-temperature-extract
      *ngIf="ventilationSensorsTemperatureExtract$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.VENTILATION.SENSOR_READINGS.EXTRACT_TEMPERATURE' | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | sensorStatusConnected | unit: 'value'
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>

    <!-- Extract humidity -->
    <!-- ventilation.sensors.humidity.extract -->
    <app-feature-list-item
      data-at-ventilation-sensors-humidity-extract
      *ngIf="ventilationSensorsHumidityExtract$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.VENTILATION.SENSOR_READINGS.EXTRACT_HUMIDITY' | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | sensorStatusConnected | unit: 'value'
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
  </div>
</app-feature-list-container>
